import {
  deleteWithBaseUrlAndToken,
  getFileWithBaseUrlAndToken,
  postTemplateWithBaseUrlAndToken,
  putFileWithBaseUrlAndToken,
} from '../fetchWithBaseUrlAndToken'

export async function requestUpdateTenantFile(path: string, data: FormData): Promise<any> {
  let uri = ''
  if (path) {
    uri = `/branding/?path=${encodeURIComponent(path)}`
  } else {
    uri = `/branding`
  }

  return await putFileWithBaseUrlAndToken(uri, data)
}

export async function requestUploadTenantFile(data: FormData, path?: string): Promise<any> {
  let uri = ''
  if (path) {
    uri = `/branding/?path=${encodeURIComponent(path)}`
  } else {
    uri = `/branding`
  }

  return await postTemplateWithBaseUrlAndToken(uri, data)
}

export async function requestDeleteTenantFile(path: string): Promise<void> {
  return await deleteWithBaseUrlAndToken(`/branding/?path=${encodeURIComponent(path)}`)
}

export async function requestDownloadTenantFile(path: string): Promise<any> {
  return await getFileWithBaseUrlAndToken(`/branding/download/?path=${encodeURIComponent(path)}`)
}
